module.exports = __webpack_public_path__ + "static/media/Icons-nav-widgets.98b163c9.svg";